module.exports = __webpack_public_path__ + "static/img/icon-hotel-type5.7f3d851b.png";